module.exports = __webpack_public_path__ + "dae5df17211ca31642e322b70b6bb428.svg";